import React from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import './css/Team.css';
import logo from './images/arjun.jpg';
import logo1 from './images/hritik.jpg';
import logo2 from './images/tanu.jpg';
import logo3 from './images/somya.jpg';
import InstagramIcon from '@material-ui/icons/Instagram';
import FacebookIcon from '@material-ui/icons/Facebook';
import { Twitter } from '@material-ui/icons';

const About = () =>{

	return(
			<>
			<div className="team-boxed">
		        <div className="container">
		            <div className="intro">
		                <h2 className="text-center">TEAM </h2>
		                <p className="text-center">We are passionate to serve our best. Let visit our developer's profile.</p>
		           </div>
		            <div className="row people">
		                <div className="col-md-6 col-lg-4 item">
		                    <div className="box"><img className="rounded-circle" src={logo} alt="Arjun patidar" />
		                        <h3 className="name">Arjun Patidar</h3>
		                        <p className="title">Team Head: React-developer</p>
		                        <p className="description">I am a <b>Full-Stack-Developer</b> 'or' a <b>Freelancer</b> and I have sufficient knowledge about web or React development with fastest client side rendering, Feel free to connect with me. 2 year experience on <b>React Development</b>. </p>
		                        <div className="teamSocial">
		                        	<a href="https://www.facebook.com/arjun.patidar.9754" className="f"><span><FacebookIcon /></span></a>
		                        	<a href="https://www.twitter.com/Arjun_patidar_/" className="t"><span><Twitter /></span></a>
		                        	<a href="https://www.instagram.com/artal_arjun_/" className="i"><span><InstagramIcon /></span></a>
		                        </div>
		                    </div>
		                </div>
		                <div className="col-md-6 col-lg-4 item">
		                    <div className="box"><img className="rounded-circle" src={logo2} alt="logo" />
		                        <h3 className="name">Tanu Yadav</h3>
		                        <p className="title">Report Analyst</p>
		                        <p className="description">Professional <b>report Analyst</b> working on bussiness report. More than one year experience. </p>
		                        <div className="teamSocial">
									<a href="https://www.facebook.com/arjun.patidar.9754" className="f"><span><FacebookIcon /></span></a>
		                        	<a href="https://www.twitter.com/Arjun_patidar_/" className="t"><span><Twitter /></span></a>
		                        	<a href="https://www.instagram.com/artal_arjun_/" className="i"><span><InstagramIcon /></span></a>
		                        </div>
		                    </div>
		                </div>
						<div className="col-md-6 col-lg-4 item">
		                    <div className="box"><img className="rounded-circle" src={logo1} alt="logo" />
		                        <h3 className="name">Hritik Dangi</h3>
		                        <p className="title">Developer</p>
		                        <p className="description">I am a <b>Freelance developer</b> and <b>marketing head</b>, Feel free to connect with me. 2 year marketing experience. </p>
		                        <div className="teamSocial">
									<a href="https://www.facebook.com/arjun.patidar.9754" className="f"><span><FacebookIcon /></span></a>
		                        	<a href="https://www.twitter.com/Arjun_patidar_/" className="t"><span><Twitter /></span></a>
		                        	<a href="https://www.instagram.com/artal_arjun_/" className="i"><span><InstagramIcon /></span></a>
		                        </div>
		                    </div>
		                </div>
		                <div className="col-md-6 col-lg-4 item">
		                    <div className="box"><img className="rounded-circle" src={logo3} alt="logo" />
		                        <h3 className="name">Somya Agrawal</h3>
		                        <p className="title">Developer</p>
		                        <p className="description">I am a <b>Freelance developer</b>, Feel free to connect. 2 year front-end designing experience. </p>
		                        <div className="teamSocial">
									<a href="https://www.facebook.com/arjun.patidar.9754" className="f"><span><FacebookIcon /></span></a>
		                        	<a href="https://www.twitter.com/Arjun_patidar_/" className="t"><span><Twitter /></span></a>
		                        	<a href="https://www.instagram.com/artal_arjun_/" className="i"><span><InstagramIcon /></span></a>
		                        </div>
		                    </div>
		                </div>
		            </div>
		        </div>
		    </div>
			</>
		);
}

export default About;